import { BaseWebService } from "./base.web.service";
import { OrganisatieUserRole } from "../models/user/userRole";

export class UserManagementWebService extends BaseWebService {

    private getRoleEndpoint(role: OrganisatieUserRole): string {
        switch (role) {
            case 'user':
                return 'basic-users';
            case 'readonlyUser':
                return 'readonly-users';
            case 'keyUser':
                return 'key-users';
            case 'admin':
                throw new Error('Admin role kan niet via deze endpoint worden toegewezen of verwijderd.');
            default:
                return 'basic-users';
        }
    }
   
    public async getUsersOrganisatie(organizationId: string, listParams: any) {
        let params = '';
        params = this.appendParam(params, '_offset', listParams?.offset);
        params = this.appendParam(params, '_limit', listParams?.limit);

        const headers = await this.getHeadersJsonForOrganization(organizationId);
        const url = `${this.appConfig.serviceUserManagementUrl}/api/v1/users${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async inviteUserForOrganisatie(organizationId: string, email: string, role: OrganisatieUserRole = 'user') {
        const headers = await this.getHeadersJsonForOrganization(organizationId);
        const userPath = this.getRoleEndpoint(role);
        const url = `${this.appConfig.serviceUserManagementUrl}/api/v1/${userPath}`;
        const body = { email };
        return this.makeRequest(url, 'POST', headers, body, 0, true);
    }

    public async deleteUserFromOrganisatie(organizationId: string, email: string, role: OrganisatieUserRole = 'user') {
        const headers = await this.getHeadersJsonForOrganization(organizationId);
        const userPath = this.getRoleEndpoint(role);
        const url = `${this.appConfig.serviceUserManagementUrl}/api/v1/${userPath}`;
        const body = { email };
        return this.makeRequest(url, 'DELETE', headers, body, 0, true); // wrapResponse: true
    }

    public async mijnOrganisaties() {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceUserManagementUrl}/api/v1/mijn-organisaties`;
        return this.makeRequest(url, 'GET', headers);
    }
}